"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SELECTED_MASTR = void 0;
exports.default = reducer;
exports.getHarnesId = exports.getContract = void 0;
exports.loadCurrentEegs = loadCurrentEegs;
exports.loadInstallationDetails = loadInstallationDetails;
exports.setSelectedEeg = setSelectedEeg;
exports.stopLoading = stopLoading;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _mastrApi = require("../api/mastrApi");
var _SessionHandler = _interopRequireDefault(require("../utils/SessionHandler"));
var _Router = _interopRequireDefault(require("../../utils/Router"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_MASTR = 'api/reducer/GET_MASTR';
var SET_SELECTED_MASTR = exports.SET_SELECTED_MASTR = 'api/reducer/SET_SELECTED_MASTR';
var LOAD_CURRENT_MASTR_DATA = 'api/reducer/GET_DEVICE_DATA';
var LOAD_CURRENT_MASTR_DATA_STARTED = 'api/reducer/LOAD_CURRENT_MASTR_DATA_STARTED';
var LOAD_CURRENT_MASTR_DATA_FAILURE = 'api/reducer/LOAD_CURRENT_MASTR_DATA_FAILURE';
var LOAD_CURRENT_MASTR_DETAILS = 'api/reducer/LOAD_CURRENT_MASTR_DETAILS';
var STOP_MASTR_DET_LOADING = 'api/reducer/STOP_MASTR_DET_LOADING';
var getHarnesId = exports.getHarnesId = function getHarnesId(contract) {
  return contract.harnesId;
};
var getContract = exports.getContract = function getContract(contracts, harnesId) {
  return contracts && contracts.find ? contracts.find(function (elem) {
    return getHarnesId(elem) === harnesId;
  }) : null;
};
// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedContract = function getPreselectedContract(devices) {
    var id = _Router.default.getParameter('harnesId');
    if (id) {
      return id;
    }
    if (devices[0]) {
      var hId = getHarnesId(devices[0]) || 'none__0';
      _Router.default.setParameter({
        harnesId: hId,
        pos: 0
      });
      return hId;
    }
    return null;
  };
  var getElemPosition = function getElemPosition() {
    var id = _Router.default.getParameter('pos');
    if (id) {
      return id;
    }
    _Router.default.setParameter({
      pos: 0
    });
    return 0;
  };
  switch (action.type) {
    case LOAD_CURRENT_MASTR:
      return _objectSpread(_objectSpread({}, state), {}, {
        contractsList: action.data.innerData,
        harnesId: getPreselectedContract(action.data.innerData),
        elemPos: getElemPosition()
      });
    case SET_SELECTED_MASTR:
      _Router.default.setParameter({
        harnesId: action.data.harnesId,
        pos: action.data.pos
      });
      _Router.default.setParameter({
        pos: action.data.pos
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        harnesId: action.data.harnesId,
        elemPos: action.data.pos,
        error: null,
        mastrDataProcceding: true
      });
    case LOAD_CURRENT_MASTR_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        mastrData: [action.data.innerData]
      });
    case LOAD_CURRENT_MASTR_DATA_STARTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        mastrDataProcceding: true
      });
    case LOAD_CURRENT_MASTR_DATA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        mastrDataProcceding: false,
        error: action.data.error
      });
    case LOAD_CURRENT_MASTR_DETAILS:
      return _objectSpread(_objectSpread({}, state), {}, {
        error: null,
        mastrDetails: action.data.innerData.details,
        mastrDataProcceding: false
      });
    case STOP_MASTR_DET_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        mastrDataProcceding: false
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrentEegs(dispatch) {
  var resp = (0, _mastrApi.getInstallationsInfo)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_MASTR,
      data: {
        innerData: reponse.data ? reponse.data.content : {}
      }
    });
  });
}
function setSelectedEeg(dispatch, harnesId, pos) {
  _SessionHandler.default.resetPermissions();
  dispatch({
    type: SET_SELECTED_MASTR,
    data: {
      harnesId: harnesId,
      pos: pos
    }
  });
}
function stopLoading(dispatch) {
  dispatch({
    type: STOP_MASTR_DET_LOADING
  });
}
function loadInstallationDetails(dispatch, selected) {
  dispatch({
    type: LOAD_CURRENT_MASTR_DATA_STARTED
  });
  var resp = (0, _mastrApi.getInstallationDetails)(selected);
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_MASTR_DETAILS,
      data: {
        innerData: reponse.data ? reponse.data : {}
      }
    });
  }).catch(function (err) {
    var errorCode;
    if (err.response.data.errors[0] && err.response.data.errors[0].code) {
      errorCode = err.response.data.errors[0].code.split('.').pop();
    }
    dispatch({
      type: LOAD_CURRENT_MASTR_DATA_FAILURE,
      data: {
        error: errorCode
      }
    });
  });
}
// export function loadDeviceData(dispatch, serialNumber, obises, dateFrom, dateTo) {
//   const resp = getDeviceData(serialNumber, obises, dateFrom, dateTo);
//   dispatch({
//     type: LOAD_CURRENT_DEVICE_DATA_STARTED,
//   });
//   return resp
//     .then((response) => {
//       dispatch({
//         type: LOAD_CURRENT_DEVICE_DATA,
//         data: {
//           innerData: response.data,
//         },
//       });
//     }).catch((err) => {
//       let errorCode;
//       if (err.response.data.errors[0] && err.response.data.errors[0].code) {
//         errorCode = err.response.data.errors[0].code.split('.').pop();
//       }
//       dispatch({
//         type: LOAD_CURRENT_DEVICE_DATA_FAILURE,
//         data: {
//           error: errorCode,
//         },
//       });
//     });
// }